import * as Config from '../config';
import React, { useContext } from "react";
import { useSelector, useDispatch, ReactReduxContext } from 'react-redux';

import { useRouteMatch, useHistory } from "react-router-dom";
import { /*useDrag,*/ useDrop } from 'react-dnd';

import {
  setDManager,
  setModal,
  setSelectedItems,
  updateStorePlaylists,
  removeStorePlaylists,
  addToast
} from "../actions/index";

import Input from '../components/library/form/Input';
import ModalCTA from '../components/library/modal/ModalCTA';
import ModalInput from '../components/library/modal/ModalInput';
import ModalButton from '../components/library/modal/ModalButton';

window.timers = [];

const usePlaylistMenu = (playlist, pathTo, isConnected, callbacks = {}) => {
  const { store } = useContext(ReactReduxContext);
  const dispatch = useDispatch();

  const playlistID = playlist ? playlist.id : null;
  const playlistName = playlist ? playlist.name : null;

  const history = useHistory();
  let match = useRouteMatch({ path: pathTo, exact: false }); //activeOnlyWhenExact
  const allowAccess = useSelector(state => state.allowAccess); // Double Tap OR Normal Click OR Touch
  const setHistory = () => {
    const state = store.getState();
    if (allowAccess) {
      state.storeRoute.goTo(pathTo);
      if (isConnected) { // FROM PARENT
        dispatch(setDManager({pathApi: `/my/playlists/?per_page=100`, type: `PLAYLIST`}));
      }
    }
  }

  const selectedItems = useSelector(state => state.selectedItems); // IMPORTANT
  const hasSelectedItems = (selectedItems.length > 0);

  const validDrop = (playlist, duplicated = []) => () => {
    const aDuplicated = duplicated.map( x => x.id );
    const state = store.getState();

    let filterSelectedItems = (callbacks && callbacks.filterSelectedItems) ? callbacks.filterSelectedItems(selectedItems) : selectedItems;

    if (isConnected) { // LINK - From Parent
      const previews = filterSelectedItems.filter( x => !aDuplicated.includes(x.id) && x.is_available_for_streaming === false );
      // const preorders = filterSelectedItems.filter( x => !aDuplicated.includes(x.id) && x.pre_order );
      const selection = filterSelectedItems.filter( x => !aDuplicated.includes(x.id) && x.is_available_for_streaming === true ).map(x => x.id);
      state.storePlaylists.addTracksToPlaylistAPI(playlist.id, selection);
      // Reporting
      const dataEvent = filterSelectedItems.map( x => {
        const source_item_type = (x.from && x.from.includes(`charts`)) ? `Playlist`: `Release`;
        const source_item_id = (x.from && x.from.includes(`charts`)) ? x.from.split(`/`).pop() : x.releaseID;
        return { track_id: x.id, source_item_type, source_item_id }
      } );
      state.storePlaylists.report(`/events/add-to-playlist/`, dataEvent);
      if (selection.length > 0) {
        dispatch(addToast({ content: <span>{selection.length} track(s) added to '{playlist.name}'.</span>, typeClass: 'success', iconStyle: { padding: 16, marginRight: 16 } }));
      }      
      if (previews.length > 0) {
        dispatch(addToast({ content: <span>{previews.length} track(s) not added to '{playlist.name}'. Download only, full-track streaming is unavailable.</span>, typeClass: 'warning', iconStyle: { padding: '32px 16px', marginRight: 16 } }));
      }
      // if (preorders.length > 0) {
      //   dispatch(addToast({ content: <span>{preorders.length} track(s) added to '{playlist.name}'. Pre-orders are not accessible through DJ platform integrations.</span>, typeClass: 'warning', iconStyle: { padding: '32px 16px', marginRight: 16 } }));
      // }
    } else { // NEW OR BASIC USER
      const selection = filterSelectedItems.filter( x => !aDuplicated.includes(x.id) );
      playlist.tracks.push(...selection);
      state.storePlaylists.update(playlist.id, `track_count`, playlist.tracks.length);
    }

    (callbacks && callbacks.afterDrop) && callbacks.afterDrop(filterSelectedItems.filter( x => !aDuplicated.includes(x.id) ));

    if (history.location.pathname === `/playlists/${playlist.id}`) { // Auto-Refresh
      setTimeout(() => {
        const key = new Date().getUTCMilliseconds();
        history.push(`/playlists/${playlist.id}/${key}`);
      }, 500);
    }

  }

  const checkDuplicate = (duplicated, playlist) => {
    const length = duplicated.length;
    if (length > 0) {
      dispatch(setModal({ //V2
        content: (
          <ModalCTA
            title={`Duplicate found`}
            description={`${length} of the selected tracks, already found in this playlist.`}
            styleContainer={{marginTop: `-60%`, marginLeft: `-10%`}}
            styleBody={{gap: 16}}
            styleGroupCta={{gap: 32}}
            classModal={`bottom-reduce`}
          >
            <ModalButton label={`Add anyway`} className={`transparent-grey`} onClick={validDrop(playlist)} keyPress={true} />
            <ModalButton label={`Skip`} className={`cancel`} onClick={validDrop(playlist, duplicated)} />
          </ModalCTA>
        )
      }))
    } else {
      validDrop(playlist)();
    }
  }

  const onDrop = () => {
    if (hasSelectedItems) {
      const state = store.getState();
      let duplicated = 0; // Check Duplication Items
      if (isConnected) { // LINK - From Parent
        state.storePlaylists.getTracks(playlist.id).then((res) => {
          const resultsTracks = res.data.results.map( x => x.track );
          duplicated = selectedItems.filter( x => resultsTracks.find(y => y.id === x.id) );
          checkDuplicate(duplicated, playlist);
        });
      } else { // NEW OR BASIC USER OR SHARED PLAYLIST
        const p = (state.storePlaylists && state.storePlaylists.get) ? state.storePlaylists.get(playlist.id) : null;
        if (p) { duplicated = selectedItems.filter( x => p.tracks.find(y => y.id === x.id) ); }
        checkDuplicate(duplicated, playlist);
      }
    }
    if (window.timers[playlistName]) { clearTimeout(window.timers[playlistName]); window.timers[playlistName] = null; }
  }

  const [{ el, canDrop, isOver /*, typeElement */ }, refDrop] = useDrop({
    accept: ['TRACK', 'PLAYLIST', 'PLAYLIST-MENU', 'CHART', 'CHART-NAV', 'TRACK-CARD', 'RELEASE', 'DECK'],
    drop: onDrop,
    collect: (monitor) => ({
      el: monitor.getItem(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      // typeElement: monitor.getItemType()
    }),
  })
  const availableDrop = (hasSelectedItems && canDrop && isOver);
  const opacity = (el && el.type === `CHART` && !hasSelectedItems) ? 0.2 : 1;

  // SORTABLE PLAYLISTS - TODO when API ENABLE the feature
  // const isDraggingPlaylists = (typeElement === 'PLAYLIST-MENU' && canDrop && isOver && draggable);
  // let [dragProps, dragRef] = useDrag({
  //   item: { id, type: `PLAYLIST-MENU` }
  // })
  // dragRef = (draggable) ? dragRef : null;
  // const onReorder = (endIndex) => (item, monitor) => sortableStorePlaylists(item.id, endIndex);
  // const styleMidDropBox = {
  //   backgroundColor : `transparent`, zIndex: 20, position: `absolute`,
  //   width: Config.SIDE_WIDTH, height: 9
  // }

  // Open like Spotify
  // if (!isDraggingPlaylists) {
  if (canDrop && isOver && !window.timers[playlistName]) {
    window.timers[playlistName] = setTimeout(() => { setHistory() }, 1000); // console.log('init timer', playlistName);
  } else if ( canDrop && !isOver && window.timers[playlistName] ) {
    clearTimeout(window.timers[playlistName]); // console.log('CLEAN AND STOP');
    window.timers[playlistName] = null;
  }
  // }


  const updateFormPlaylist = () => {
    dispatch(setSelectedItems([])); //FORCE
    const validClick = (data) => {
      const state = store.getState();
      (state.isConnected) && state.api.patch(`/my/playlists/${playlistID}`, { name: data });
      dispatch(addToast({ content: <span>Playlist renamed.</span>, typeClass: 'success', iconStyle: { padding: 16, marginRight: 16 } }));
      dispatch(updateStorePlaylists(playlistID, `name`, data));
      if (history.location.pathname.includes(playlistID)) {
        setTimeout(() => {
          const key = new Date().getUTCMilliseconds();
          history.push(`${pathTo}/${key}`);
        }, 500);
      }
    }
    dispatch(setModal({ //V2
      content: (
        <ModalCTA
          title={`Rename playlist`}
          styleContainer={{marginTop: `-60%`, marginLeft: `-10%`}}
          styleBody={{gap: 16}}
          styleGroupCta={{gap: 32}}
          classModal={`bottom-reduce`}
        >
          <Input label={`Name`} labelValid={`Save`} validClick={validClick} placeholder={`My Playlist`} value={playlistName} />
        </ModalCTA>
      )
    }));
  };
  const deleteFormPlaylist = () => {
    const validClick = () => {
      const state = store.getState();
      (state.isConnected) && state.api.del(`/my/playlists/${playlistID}`);
      dispatch(removeStorePlaylists(playlistID));
      dispatch(addToast({ content: <span>Playlist '{playlistName}' deleted.</span>, typeClass: 'neutral', iconStyle: { padding: 16, marginRight: 16 } }));
      (history.location.pathname.includes(playlistID)) && history.push(`/home`);
    };
    dispatch(setModal({
      content: (
        <ModalCTA
          title={`Delete playlist`}
          description={`Are you sure you want to delete '${playlistName}'?`}
          styleContainer={{marginTop: `-60%`, marginLeft: `-10%`}}
          classModal={`bottom-reduce`}
        >
          <ModalButton label={`Delete`} className={`red-white`} onClick={validClick} keyPress={true} />
          <ModalButton label={`Cancel`} className={`cancel`} />
        </ModalCTA>
      )
    }));

  }
  const duplicateFormPlaylist = () => { //ONLY AVAILABLE TO CONNECTED USER
    const validClick = (name) => {
      const state = store.getState();
      state.api.getFromApi(`/my/playlists/${playlistID}/tracks/?per_page=100`, false).then( response => {
        const next = response.data.next;
        const data = response.data.results.map(x => x.track).map(Config.formattedFromBP);
        state.storePlaylists.new(name, data, {}, next);
        const dataEvent = data.map( x => ({ track_id: x.id, source_item_type: `Playlist`, source_item_id: playlistID }) );
        state.storePlaylists.report(`/events/save-to-library/`, dataEvent);
        dispatch(addToast({ content: <span>Playlist '{name}' duplicated.</span>, typeClass: 'success', iconStyle: { padding: 16, marginRight: 16 } }));
      } ).catch( e => console.log(`error`, e) );
    }
    // dispatch(setModal({ //V2
    //   content: (
    //     <ModalCTA
    //       title={`Duplicate This Playlist`}
    //       styleContainer={{marginTop: `-60%`, marginLeft: `-10%`}}
    //       styleBody={{gap: 16}}
    //       styleGroupCta={{gap: 32}}
    //       classModal={`bottom-reduce`}
    //     >
    //       <Input label={`Name`} labelValid={`Create`} validClick={validClick} placeholder={`My Playlist`} value={playlistName} />
    //     </ModalCTA>
    //   )
    // }));
    validClick(playlistName);
  };
  const copySharedPlaylist = () => {
    const state = store.getState();
    const isConnected = state.isConnected;

    if (isConnected) {
      const validClick = (name) => {
        const state = store.getState();
        const sharedPlaylist = state.storePlaylists.get(Config.UID_SHARED_PLAYLIST);
        if (sharedPlaylist) {
          const data = sharedPlaylist.tracks;
          state.storePlaylists.new(name, sharedPlaylist.tracks, {});
          const dataEvent = data.map( x => ({ track_id: x.id, source_item_type: `Playlist`, source_item_id: playlistID }) );
          state.storePlaylists.report(`/events/save-to-library/`, dataEvent);
        }
      }
      dispatch(setModal({
        content: (
          <ModalCTA
            title={`Save set playlist`}
            styleContainer={{marginTop: `-60%`, marginLeft: `-10%`}}
            styleBody={{gap: 16}}
            styleGroupCta={{gap: 16}}
            classModal={`bottom-reduce`}
          >
            <ModalInput
              value={playlistName} placeholder={`Name your playlist`}
              validClick={validClick} validLabel={`Save`}
              inputClassName={'modal-input-split'}
            />
          </ModalCTA>
        )
      }));
    } else {
      state.storeAuth.signupPM();
    }

  }
  const copySuggestedPlaylist = () => {
    const state = store.getState();
    const isConnected = state.isConnected;

    if (isConnected) {
      const validClick = (name) => {
        const state = store.getState();
        const sharedPlaylist = state.storePlaylists.get(Config.UID_SUGGESTED_PLAYLIST);
        if (sharedPlaylist) {
          const data = sharedPlaylist.tracks;
          state.storePlaylists.new(name, sharedPlaylist.tracks, {});
          const dataEvent = data.map( x => ({ track_id: x.id, source_item_type: `Playlist`, source_item_id: playlistID }) );
          state.storePlaylists.report(`/events/save-to-library/`, dataEvent);
        }
      }
      dispatch(setModal({
        content: (
          <ModalCTA
            title={`Save Session Requests`}
            styleContainer={{marginTop: `-60%`, marginLeft: `-10%`}}
            styleBody={{gap: 16}}
            styleGroupCta={{gap: 16}}
            classModal={`bottom-reduce`}
          >
            <ModalInput
              value={playlistName} placeholder={`Name your playlist`}
              validClick={validClick} validLabel={`Create`}
              inputClassName={'modal-input-split'}
            />
          </ModalCTA>
        )
      }));
    } else {
      state.storeAuth.signupPM();
    }
  }
  const toStore = () => { window.open(`https://www.${Config.API_NAME}.com/library/playlists/${playlistID}`, `_blank`) }

  const storeX = {
    match,
    setHistory,

    availableDrop,
    opacity,
    canDrop,
    isOver,
    refDrop,

    updateFormPlaylist,
    deleteFormPlaylist,
    duplicateFormPlaylist,
    copySharedPlaylist,
    copySuggestedPlaylist,
    toStore
  };

  return storeX;
};

export default usePlaylistMenu;
